<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="传感器类型" prop="sensorModelId">
              <j-search-select-tag
                @change="changeSensorModel"
                dict="`iwt-wf`.iot_sensor_model,model_name,id, 1=1 order by model_name asc"
                placeholder="请选择传感器类型"
                v-model="model.sensorModelId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="传感器名称" prop="sensorName">
              <a-input placeholder="请输入传感器名称" v-model="model.sensorName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="逻辑地址" prop="logicAddr">
              <a-input placeholder="请输入逻辑地址" v-model="model.logicAddr"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="区域" prop="processId">
              <j-dict-select-tag
                @change="changeProcess"
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                v-model="model.processId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备" prop="devId">
              <j-search-select-tag :dictOptions="devList" placeholder="请选择设备" v-model="model.devId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装点" prop="installPoint">
              <a-input placeholder="请输入安装点" v-model="model.installPoint"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装点编号" prop="installPointCode">
              <a-input placeholder="请输入安装点编号" v-model="model.installPointCode"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经纬度(谷歌)" prop="coordinateWgs84">
              <a-input placeholder="使用逗号分隔,例:116.308659, 30.914005" v-model="model.coordinateWgs84"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经纬度(高德)" prop="coordinateGcj02">
              <a-input placeholder="使用逗号分隔,例:116.308659, 30.914005" v-model="model.coordinateGcj02"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装时间" prop="installTime">
              <j-date
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择安装时间"
                style="width: 100%"
                v-model="model.installTime"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="固件版本" prop="firmwareVersion">
              <a-input placeholder="请输入固件版本" v-model="model.firmwareVersion"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="照片" prop="pictureObjId">
              <j-image-upload bizPath="sensor" isMultiple v-model="model.pictureObjId"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="二维码" prop="qrcode">
              <j-image-upload bizPath="sensor" v-model="model.qrcode"></j-image-upload>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注" prop="description">
              <a-textarea placeholder="请输入备注" rows="3" v-model="model.description" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'IotSensorListForm',
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 }
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 }
        },
        confirmLoading: false,
        validatorRules: {
          sensorName: [{ required: true, message: '请输入传感器名称!' }],
          sensorModelId: [{ required: true, message: '请输入类型ID!' }],
          location: [{ required: true, message: '请输入安装位置!' }]
        },
        url: {
          add: '/monitor/sensor/add',
          edit: '/monitor/sensor/edit',
          queryById: '/monitor/sensor/queryById',
          devList: '/device/devList/list',
          queryProcessByid: '/device/devProcess/queryById'
        },
        devList: []
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
    },
    methods: {
      add () {
        this.edit(this.modelDefault)
      },
      edit (record) {
        this.model = Object.assign({}, record)
        this.visible = true
        this.getDevList()
      },
      submitForm () {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            httpAction(httpurl, this.model, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      },
      getDevList (processId) {
        processId = processId || this.model.processId
        this.devList = []
        const parms = {
          pageSize: 9999,
          column: 'sort',
          order: 'asc'
        }
        if (processId) {
          parms.devProcessId = processId
        }
        getAction(this.url.devList, parms).then(res => {
          if (res.result.records.length > 0) {
            res.result.records.forEach(row => {
              this.devList.push({
                value: row.id,
                text: row.devName
              })
            })
          }
        })
      },
      setSensorLocation (key) {
        getAction(this.url.queryProcessByid, { id: key }).then(res => {
          if (res.result && res.result.coordinateWgs84) {
            this.model.coordinateWgs84 = res.result.coordinateWgs84
          }
        })
      },
      changeProcess (key) {
        this.getDevList(key)
        this.setSensorLocation(key)
      },
      changeSensorModel (key, text) {
        if (!this.model.sensorName) {
          this.model.sensorName = text
        } else {
          if (!this.model.id) {
            this.model.sensorName = text
          }
        }
      }
    }
  }
</script>
